// extracted by mini-css-extract-plugin
export default {"overlay":"backgroundOverlay_overlay__ET8gB"};